module.exports = __webpack_public_path__ + "img/the-starter.540e49c7.png";